import * as t from 'io-ts';
import { createLocalStorageItem } from 'src/domains/layouts/state/localStorage/createLocalStorageItem';
import { LocalStorageItemState } from 'src/domains/layouts/state/localStorage/LocalStorageItemState';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';

const decodeIO = t.union([
    t.number,
    t.null
]);

const decode = buildValidator('localStorageCgLanging.decodeIO', decodeIO, true);

export const localStorageCgLanging = (withAutorun: boolean, key: string): LocalStorageItemState<number | null> => {
    return createLocalStorageItem(withAutorun, {
        key: key,
        decode: decode,
        defaultValue: null
    });
};
